"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("./styles");
function Step(props) {
    var label = props.children &&
        react_1.default.Children.map(props.children, function (child) {
            return react_1.default.cloneElement(child, {
                active: props.active,
                color: props.style && props.style.color,
            });
        });
    var position;
    if (props.index === 0)
        position = 'first';
    else if (props.index === (props.stepsCount || 0) - 1)
        position = 'last';
    return (react_1.default.createElement(styles_1.MainContainer, { style: props.style, className: props.className },
        react_1.default.createElement(styles_1.Bar, { active: props.active, completed: props.completed, position: position, color: props.style && props.style.color, style: props.style && props.style.bar }),
        label));
}
exports.default = Step;
//# sourceMappingURL=index.js.map